import { ThreeDotMenu } from '@openhouse-engineers/rrc'
import React from 'react'
import { useSelector } from 'react-redux'

import Avatar from 'components/common/Avatar'
import Text from 'components/common/Text'
import { Color } from 'constants/color'
import { _dominantSpeaker } from 'store/selectors/Room'

import { ListItem, AvatarWrapper, AVStatusIcon, Identity, Para } from './styles'

const BASE = 'assets/revamp'

const Participant = ({ participant = {} }) => {
    const {
        id,
        name,
        isElsewhere,
        isAudioEnabled,
        isVideoEnabled,
        isScreenSharing,
    } = participant

    /* active speaker */
    const dominantSpeakerId = useSelector(_dominantSpeaker)
    const isActiveSpeaker = dominantSpeakerId === id

    const [firstName] = name.split(' ')

    const cameraStatus = isVideoEnabled ? 'on' : 'off'
    const audioStatus = isAudioEnabled ? 'on' : 'off'

    /* text */
    let textColor = Color.unknownColor24
    textColor = isElsewhere ? Color.unknownColor25 : textColor
    textColor = isScreenSharing ? Color.unknownColor23 : textColor

    let text = firstName
    const verb = firstName === 'You' ? 'are' : 'is'
    text = isElsewhere ? `${firstName} ${verb} elsewhere` : text
    text = isScreenSharing ? `${firstName} ${verb} sharing screen` : text

    return (
        <ListItem.Area isScreensharing={isScreenSharing}>
            <ListItem.LeftSection>
                <AVStatusIcon
                    disabled
                    src={`${BASE}/camera-${cameraStatus}.svg`}
                    alt="video-status"
                />
                <Identity>
                    <AvatarWrapper
                        isActiveSpeaker={isActiveSpeaker}
                        isScreensharing={isScreenSharing}
                    >
                        <Avatar uuid={id} />
                    </AvatarWrapper>
                    <Text level="2" color={textColor}>
                        <Para>{text}</Para>
                    </Text>
                </Identity>
            </ListItem.LeftSection>
            <ListItem.RightSection>
                <AVStatusIcon
                    disabled
                    src={`${BASE}/mic-${audioStatus}.svg`}
                    alt="audio-status"
                />
                <ThreeDotMenu iconColor="rgba(229, 229, 229, 0.5)"></ThreeDotMenu>
            </ListItem.RightSection>
        </ListItem.Area>
    )
}

export default Participant
